import { BaseService } from "./baseService";
import { User } from "../types";
import { createActiveUsersFilter } from "../utils/apiHelpers";

class UserService extends BaseService<User> {
  constructor() {
    super("User");
    this.setCacheStrategy("cache-first");
    this.setCacheExpiry(30 * 60 * 1000);
  }

  async getUsers(offset = 0, maxSize = 50): Promise<User[]> {
    const selectFields = [
      "emailAddressIsOptedOut",
      "emailAddressIsInvalid",
      "emailAddress",
      "emailAddressData",
      "userName",
      "salutationName",
      "firstName",
      "lastName",
      "middleName",
      "name",
    ];

    try {
      const result = await this.getList({
        select: selectFields,
        where: createActiveUsersFilter(),
        offset,
        maxSize,
        orderBy: "userNameOwnFirst",
        order: "asc",
      });
      return result.list;
    } catch (err) {
      console.error("Ошибка при получении пользователей:", err);
      return [];
    }
  }
}

export const userService = new UserService();

export type { User };
export const getUsers = (offset = 0, maxSize = 50) =>
  userService.getUsers(offset, maxSize);
